export class ItemClassification {
  /**
   * The unique Item Classification Code used to categorize items.
   */
  itemClsCd: string;

  /**
   * The Item Classification Name, describing the category of items.
   */
  itemClsNm: string;

  /**
   * The classification level indicating the depth of the category in the classification hierarchy.
   */
  itemClsLvl: number;

  /**
   * The associated Tax Type Code.
   */
  taxTyCd: string;

  /**
   * Indicates whether the classification is a major target category.
   */
  mjrTgYn: string;

  /**
   * Specifies whether the classification is active ("Y" = Yes, "N" = No).
   */
  useYn: string;

  /**
   * A searchable string combining the classification code and name for easy lookup.
   */
  searchString: string;

  /**
   * Unique identifier for the classification in the system.
   */
  id: number;

  /**
   * The name field.
   */
  name: string;

  /**
   * Timestamp indicating when the classification was created.
   */
  createdAt: Date;

  /**
   * Timestamp indicating when the classification was last updated.
   */
  updatedAt: Date;

  constructor(init?: Partial<ItemClassification>) {
    Object.assign(this, init);
  }
}
